/**
 * Página de Erro 503 - Serviço indisponível
 * Fidelidade visual pixel-perfect com o original Rails
 */
import { useTranslation } from 'react-i18next';

export function Error503Page() {
  const { t } = useTranslation();
  return (
    <div
      id="erro_container"
      className="text-center w-full mt-[100px]"
    >
      <div className="mx-auto my-0 h-[90px]">
        <div className="text-[68px]">{t('views.errors.unavailable_title', 'Serviço indisponível')}</div>
        <div className="text-[22px]">
          {t('views.errors.unavailable_text', 'No momento o serviço de leituras não está disponível. Tente mais tarde')}
        </div>
      </div>
    </div>
  );
}
